import { useCallback } from 'react';

import { AppModel, AppStatus, useUpdateApp } from '../../../../modules/Apps';
import { ConfirmationDialog } from '../../../common/ConfirmationDialog';
import { useToastNotification } from '../../../common/Toaster';

interface DeactivateAppDialogProps {
  isOpen: boolean;
  handleClose: VoidFunction;
  app: AppModel;
}
export function DeactivateAppDialog({
  isOpen,
  handleClose,
  app: { appId },
}: DeactivateAppDialogProps) {
  const { mutateAsync, isPending } = useUpdateApp();
  const toaster = useToastNotification();

  const deactivateApp = useCallback(async () => {
    try {
      await mutateAsync({ appId, status: AppStatus.Disabled });
      toaster.showSuccess('Application was successfully deactivated!');
      handleClose();
    } catch (error) {
      toaster.showError(
        'There was an error deactivating the application. Please, try again later.',
      );
    }
  }, [mutateAsync, appId, toaster, handleClose]);

  return (
    <ConfirmationDialog
      isOpen={isOpen}
      confirmButtonLabel="Deactivate"
      heading="Deactivate Application"
      text="Are you sure you want to deactivate this Application?"
      handleConfirm={deactivateApp}
      handleDismiss={handleClose}
      destructive
      isConfirmDisabled={isPending}
    ></ConfirmationDialog>
  );
}
